<div class="container">
  <div class="row">
    <div class="col-7 mt-5 mb-5 py-5 mx-auto">

      <div class="row mb-2">
        <div class="col-12">
          <h1>Reset Password</h1>
          <p>Please enter a new password that will be associated with your account.</p>
        </div>
      </div>

      <app-reset-password-form></app-reset-password-form>

    </div>
  </div>
</div>
